/**
 * ニュース
 */
import Moment from 'moment'
import news_list from '../news/news_list.json'

export class News {
  constructor () {
    this.list = news_list.filter(function (news) {
      return news.is_show
    }).map(function (news) {
      news.date = new Date(Date.parse(news.date))
      news.formatDate = Moment(news.date).format('YYYY.MM.DD')
      return news
    })
  }
}
